export const setActivePatientsCount = (state, count) => {
    state.count = count
}

export const setIsLoadingActivePatientsCount = (state, value) => {
    state.isLoading = value
}
